export { default } from './Modal';



// WEBPACK FOOTER //
// ./src/client/js/view/components/Modal/index.js